import React from 'react'
import DropdownFilter from '../ui/DropdownFilter/DropdownFilter'
import styles from './EventsLayout.module.scss'
import classNames from 'classnames'

const EventsFilter = ({
  eventFilter,
  sortFilter,
  handleFilterChange,
  selectedFilter,
}) => {
  return (
    <div
      className={classNames(styles['filter-container'], {
        [styles['single-item']]: !eventFilter,
      })}
    >
      {eventFilter && (
        <DropdownFilter
          title={eventFilter?.label}
          options={eventFilter?.list}
          selectedOption={selectedFilter?.selectedEvent}
          selectedOptionKey={'selectedEvent'}
          handleChange={handleFilterChange}
          className={styles.eventsFilter}
        />
      )}
      {sortFilter && (
        <DropdownFilter
          title={sortFilter?.label}
          options={sortFilter?.list}
          selectedOption={selectedFilter?.selectedSort}
          selectedOptionKey={'selectedSort'}
          handleChange={handleFilterChange}
          className={styles.sortByFilter}
        />
      )}
    </div>
  )
}

export default EventsFilter
